module.exports = __webpack_public_path__ + "img/Frame1.fb2ae9c5.png";